import { render, staticRenderFns } from "./create_trivia_page.vue?vue&type=template&id=71961ea8&scoped=true"
import script from "./create_trivia_page.vue?vue&type=script&lang=js"
export * from "./create_trivia_page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71961ea8",
  null
  
)

export default component.exports